import { IOWidget, Action, Pair, nothing, Unit } from "widgets-for-react";
import { ExtraImages } from "../../utils/extra_images.mod";
import { BlockData, CMSState } from "../../../cms/blocks/types.gen";
import { Block } from "../../../wordpress/types_and_parser/standard_blocks.gen";
import { MediaBlockProps, MediaBlockStyle, MediaBlock } from "./widgets/mediaBlock";
import { IframeBlockProps, IframeBlockStyle, IframeBlock } from "./widgets/iframeBlock";
import { CustomBlock } from "../../../wordpress/types_and_parser/custom_blocks.mod";
import { DownloadBlock, DownloadBlockProps } from "./widgets/downloadsBlock";
import { QuoteBlock, QuoteBlockProps, QuoteBlockStyle } from "./widgets/quoteBlock";
import { HeaderBlockProps, HeaderBlockStyle, HeaderBlock } from "./widgets/headerBlock.mod";
import { PublicSite_CustomPageData } from "../../application.mod";
import { CtaBlockStyle, CtaBlockProps, CtaBlock } from "./widgets/ctaBlock";
import { TableBlock, TableBlockProps, TableBlockStyle } from "./widgets/tableBlock.mod";
import { PublicSiteState } from "../../../public_site.main.mod";
import { ImageTextBlockProps, ImageTextBlockStyle, ImageTextBlock } from "./widgets/imageTextBlock.mod";
import { GridBlock, GridBlockStyle, GridBlockProps } from "./widgets/gridBlock.mod";
import { ImageStackBlockProps, ImageStackBlockStyle, ImageStackBlock } from "./widgets/imageStackBlock";
import { FactsAndImageBlock, FactsAndFiguresBlockProps, FactsAndImageBlockStyle } from "./widgets/factsAndImageBlock";
import { TextBlockProps, TextBlock, TextBlockStyle } from "./widgets/textBlock";
import { FeaturedContentBlockProps, FeaturedContentBlock } from "./widgets/featuredContentBlock";
import { LinkBlockProps, LinkBlock } from "./widgets/linkBlock";
import { GridHighlightsBlock, GridHighlightsBlockProps, GridHighlightsBlockStyle } from "./widgets/gridHighlightsBlock";
import { CarouselBlock, CarouselBlockProps, CarouselBlockStyle } from './widgets/carouselBlock'
import { TimeLineBlockProps, TimeLineBlockStyle, TimeLineBlock } from "./widgets/timeLineBlock";
import { OtherThemesBlock, OtherThemesBlockProps, OtherThemesBlockStyle } from "./widgets/otherThemes";
import { FeaturedThemesBlockProps, FeaturedThemesBlockStyle, FeaturedThemesBlock } from "./widgets/featuredThemes";
import { SidebarBlockProps, SidebarBlockStyle, SideBarBlock } from "./widgets/sidebarBlock";
import { ThemesOverviewBlockProps, ThemsesOverviewBlock } from "./widgets/ThemesOverview";


//add here your custom blocks definitions
export type ctaBlockData = { kind: 'ctaBlock'; value: Pair<CtaBlockProps<ExtraImages>, CtaBlockStyle> }
export type downloadsBlockData = { kind: 'downloadsBlock'; value: Pair<DownloadBlockProps, any> }
export type headerBlockData = { kind: 'headerBlock'; value: Pair<HeaderBlockProps<ExtraImages>, HeaderBlockStyle> }
export type iframeBlockData = { kind: "iframeBlock"; value: Pair<IframeBlockProps, IframeBlockStyle> }
export type mediaBlockData = { kind: "mediaBlock"; value: Pair<MediaBlockProps<ExtraImages>, MediaBlockStyle> }
export type quoteBlockData<extra_images> = { kind: "customQuoteBlock"; value: Pair<QuoteBlockProps<extra_images>, QuoteBlockStyle> }
export type tableBlockData = { kind: 'tableBlock'; value: Pair<TableBlockProps, TableBlockStyle> }
export type imageTextBlockData = { kind: 'imageTextBlock'; value: Pair<ImageTextBlockProps<ExtraImages>, ImageTextBlockStyle> }
export type gridBlockData = { kind: 'gridBlock'; value: Pair<GridBlockProps<ExtraImages>, GridBlockStyle> }
export type gridHighlightsBlockData = { kind: 'gridHighlightsBlock'; value: Pair<GridHighlightsBlockProps<ExtraImages>, GridHighlightsBlockStyle> }
export type carouselBlockData = { kind: 'carouselBlock'; value: Pair<CarouselBlockProps<ExtraImages>, CarouselBlockStyle> }
export type gridWithImageBlockData = { kind: 'gridWithImageBlock'; value: Pair<GridBlockProps<ExtraImages>, GridBlockStyle> }
export type imageStackBlockData = { kind: 'imageStackBlock'; value: Pair<ImageStackBlockProps<ExtraImages>, ImageStackBlockStyle> }
export type factsAndFiguresBlockData = { kind: 'factsAndImageBlock'; value: Pair<FactsAndFiguresBlockProps<ExtraImages>, FactsAndImageBlockStyle> }
export type textBlockData = { kind: 'textBlock'; value: Pair<TextBlockProps<CustomBlockData, ExtraImages>, TextBlockStyle> }
export type featuredContentBlockData = { kind: 'featuredContentBlock'; value: Pair<FeaturedContentBlockProps<CustomBlockData, ExtraImages>, any> }
export type linkListBlockData = { kind: 'linkListBlock'; value: Pair<LinkBlockProps, Unit> }
export type timeLineBlockData = { kind: 'timeLineBlock', value: Pair<TimeLineBlockProps<TimeLineBlockStyle, ExtraImages>, Unit> }
export type otherThemesBlockData = { kind: 'otherThemesBlock', value: Pair<OtherThemesBlockProps<OtherThemesBlockStyle, ExtraImages>, Unit> }
export type featuredThemeBlockData = { kind: 'featuredThemesBlock', value: Pair<FeaturedThemesBlockProps<FeaturedThemesBlockStyle, ExtraImages>, Unit> }
export type sidebarBlockData = { kind: 'sidebarBlock', value: Pair<SidebarBlockProps<SidebarBlockStyle, ExtraImages>, Unit> }
export type themesOverviewBlockData = { kind: 'themesOverviewBlock', value: Pair<ThemesOverviewBlockProps<ExtraImages>, Unit> }

export type CustomBlockData =
    ctaBlockData
    | downloadsBlockData
    | headerBlockData
    | iframeBlockData
    | mediaBlockData
    | quoteBlockData<ExtraImages>
    | tableBlockData
    | imageTextBlockData
    | gridBlockData
    | gridHighlightsBlockData
    | carouselBlockData
    | gridWithImageBlockData
    | imageStackBlockData
    | factsAndFiguresBlockData
    | textBlockData
    | featuredContentBlockData
    | linkListBlockData
    | timeLineBlockData
    | otherThemesBlockData
    | featuredThemeBlockData
    | sidebarBlockData
    | themesOverviewBlockData

export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
    return b.kind == "ctaBlock" ||
        b.kind == "downloadsBlock" ||
        b.kind == "headerBlock" ||
        b.kind == "iframeBlock" ||
        b.kind == "mediaBlock" ||
        b.kind == "customQuoteBlock" ||
        b.kind == "tableBlock" ||
        b.kind == "imageTextBlock" ||
        b.kind == "gridBlock" ||
        b.kind == "gridHighlightsBlock" ||
        b.kind == "carouselBlock" ||
        b.kind == "imageStackBlock" ||
        b.kind == "factsAndImageBlock" ||
        b.kind == 'textBlock' ||
        b.kind == 'featuredContentBlock' ||
        b.kind == 'linkListBlock' ||
        b.kind == 'gridWithImageBlock' ||
        b.kind == 'timeLineBlock' ||
        b.kind == 'otherThemesBlock' ||
        b.kind == 'featuredThemesBlock' ||
        b.kind == 'sidebarBlock' ||
        b.kind == 'themesOverviewBlock'
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
    return b.kind == "vidda/media" ||
        b.kind == "vidda/download" ||
        b.kind == "vidda/quote" ||
        b.kind == "vidda/iframe" ||
        b.kind == "vidda/header" ||
        b.kind == "vidda/cta" ||
        b.kind == "vidda/table" ||
        b.kind == "vidda/image-text" ||
        b.kind == "vidda/grid" ||
        b.kind == "vidda/grid-highlights" ||
        b.kind == "vidda/carousel" ||
        b.kind == "vidda/image-stack" ||
        b.kind == "vidda/facts-and-image" ||
        b.kind == 'vidda/text' ||
        b.kind == 'vidda/featured-content' ||
        b.kind == 'vidda/link-list' ||
        b.kind == 'vidda/grid-with-image' ||
        b.kind == 'vidda/time-line' ||
        b.kind == 'vidda/other-themes' ||
        b.kind == 'vidda/featured-themes' ||
        b.kind == 'vidda/sidebar' ||
        b.kind == 'vidda/themes-overview'
}

export function renderCustomBlock(block: CustomBlockData, public_state: PublicSiteState, key?: string): IOWidget<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
    return s0 => {
        if (block.kind == "ctaBlock") {
            return CtaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "downloadsBlock") {
            return DownloadBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "headerBlock") {
            return HeaderBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "iframeBlock") {
            return IframeBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "mediaBlock") {
            return MediaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "customQuoteBlock") {
            return QuoteBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "carouselBlock") {
            return CarouselBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "tableBlock") {
            return TableBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "imageTextBlock") {
            return ImageTextBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "gridBlock") {
            return GridBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "gridHighlightsBlock") {
            return GridHighlightsBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "imageStackBlock") {
            return ImageStackBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "factsAndImageBlock") {
            return FactsAndImageBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "textBlock") {
            return TextBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "featuredContentBlock") {
            return FeaturedContentBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else if (block.kind == "linkListBlock") {
            return LinkBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == 'timeLineBlock') {
            return TimeLineBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "otherThemesBlock") {
            return OtherThemesBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "featuredThemesBlock") {
            return FeaturedThemesBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "sidebarBlock") {
            return SideBarBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "themesOverviewBlock") {
            return ThemsesOverviewBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else {
            return nothing();
        }
    }
}
